import React, { useState } from "react";
import { Link } from "react-router-dom";
import AuthGuard from "../../../components/shared/AuthGuard";

function DienDan() {
  const [activeTab, setActiveTab] = useState("news");

  return (
    <AuthGuard
      feature="Diễn đàn"
      message="Bạn cần đăng nhập để xem và tham gia diễn đàn"
      showLockIcon={true}
      blurContent={true}
    >
      <div className="dien-dan-page">
        <div className="page-header">
          <h1>Diễn đàn</h1>
          <p>Thảo luận, chia sẻ kinh nghiệm và cập nhật tin tức</p>
        </div>

        <div className="content-section">
          <div className="container">
            {/* Tab Navigation */}
            <div className="tab-navigation">
              <button
                className={`tab-btn ${activeTab === "news" ? "active" : ""}`}
                onClick={() => setActiveTab("news")}
              >
                Tin tức
              </button>
              <button
                className={`tab-btn ${
                  activeTab === "discussions" ? "active" : ""
                }`}
                onClick={() => setActiveTab("discussions")}
              >
                Thảo luận
              </button>
              <button
                className={`tab-btn ${activeTab === "tips" ? "active" : ""}`}
                onClick={() => setActiveTab("tips")}
              >
                Mẹo hay
              </button>
            </div>

            {/* Tab Content */}
            <div className="tab-content">
              {activeTab === "news" && (
                <div className="news-section">
                  <h2>Tin tức mới nhất</h2>
                  <div className="news-grid">
                    <div className="news-card">
                      <div className="news-image">
                        <div className="news-placeholder">📰</div>
                      </div>
                      <div className="news-content">
                        <h3>Xu hướng mua bán online năm 2024</h3>
                        <p>
                          Khám phá những xu hướng mới trong thương mại điện tử
                          và cách tận dụng chúng để bán hàng hiệu quả hơn.
                        </p>
                        <div className="news-meta">
                          <span className="news-date">15/12/2024</span>
                          <span className="news-views">1.2k lượt xem</span>
                        </div>
                      </div>
                    </div>

                    <div className="news-card">
                      <div className="news-image">
                        <div className="news-placeholder">💡</div>
                      </div>
                      <div className="news-content">
                        <h3>Hướng dẫn chụp ảnh sản phẩm đẹp</h3>
                        <p>
                          Bí quyết chụp ảnh sản phẩm thu hút khách hàng với
                          những mẹo đơn giản mà hiệu quả.
                        </p>
                        <div className="news-meta">
                          <span className="news-date">12/12/2024</span>
                          <span className="news-views">856 lượt xem</span>
                        </div>
                      </div>
                    </div>

                    <div className="news-card">
                      <div className="news-image">
                        <div className="news-placeholder">🛡️</div>
                      </div>
                      <div className="news-content">
                        <h3>Cách tránh lừa đảo khi mua bán online</h3>
                        <p>
                          Những dấu hiệu nhận biết và cách phòng tránh các hình
                          thức lừa đảo phổ biến trong mua bán online.
                        </p>
                        <div className="news-meta">
                          <span className="news-date">10/12/2024</span>
                          <span className="news-views">2.1k lượt xem</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === "discussions" && (
                <div className="discussions-section">
                  <h2>Thảo luận nổi bật</h2>
                  <div className="discussions-grid">
                    <div className="discussion-card">
                      <div className="discussion-header">
                        <div className="discussion-avatar">👤</div>
                        <div className="discussion-info">
                          <h3>Kinh nghiệm mua điện thoại cũ</h3>
                          <p>
                            Chia sẻ kinh nghiệm mua điện thoại cũ an toàn và
                            chất lượng
                          </p>
                        </div>
                      </div>
                      <div className="discussion-stats">
                        <span>💬 24 bình luận</span>
                        <span>👍 156 lượt thích</span>
                        <span>📅 2 ngày trước</span>
                      </div>
                    </div>

                    <div className="discussion-card">
                      <div className="discussion-header">
                        <div className="discussion-avatar">👤</div>
                        <div className="discussion-info">
                          <h3>Cách định giá sản phẩm hợp lý</h3>
                          <p>
                            Làm thế nào để định giá sản phẩm vừa cạnh tranh vừa
                            có lợi nhuận?
                          </p>
                        </div>
                      </div>
                      <div className="discussion-stats">
                        <span>💬 18 bình luận</span>
                        <span>👍 89 lượt thích</span>
                        <span>📅 3 ngày trước</span>
                      </div>
                    </div>

                    <div className="discussion-card">
                      <div className="discussion-header">
                        <div className="discussion-avatar">👤</div>
                        <div className="discussion-info">
                          <h3>Review các shop uy tín</h3>
                          <p>
                            Chia sẻ kinh nghiệm mua hàng từ các shop đáng tin
                            cậy
                          </p>
                        </div>
                      </div>
                      <div className="discussion-stats">
                        <span>💬 31 bình luận</span>
                        <span>👍 203 lượt thích</span>
                        <span>📅 1 tuần trước</span>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === "tips" && (
                <div className="tips-section">
                  <h2>Mẹo hay</h2>
                  <div className="tips-grid">
                    <div className="tip-card">
                      <div className="tip-icon">📸</div>
                      <h3>Chụp ảnh sản phẩm</h3>
                      <ul>
                        <li>Sử dụng ánh sáng tự nhiên</li>
                        <li>Chụp nhiều góc độ</li>
                        <li>Làm nổi bật chi tiết</li>
                      </ul>
                    </div>

                    <div className="tip-card">
                      <div className="tip-icon">💰</div>
                      <h3>Định giá sản phẩm</h3>
                      <ul>
                        <li>Nghiên cứu giá thị trường</li>
                        <li>Tính toán chi phí</li>
                        <li>Để lại khoảng thương lượng</li>
                      </ul>
                    </div>

                    <div className="tip-card">
                      <div className="tip-icon">📝</div>
                      <h3>Viết mô tả hấp dẫn</h3>
                      <ul>
                        <li>Tiêu đề thu hút</li>
                        <li>Mô tả chi tiết</li>
                        <li>Thông tin liên hệ rõ ràng</li>
                      </ul>
                    </div>

                    <div className="tip-card">
                      <div className="tip-icon">🛡️</div>
                      <h3>An toàn giao dịch</h3>
                      <ul>
                        <li>Kiểm tra thông tin người bán</li>
                        <li>Gặp mặt trực tiếp</li>
                        <li>Kiểm tra sản phẩm kỹ lưỡng</li>
                      </ul>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <style jsx>{`
          .dien-dan-page {
            min-height: 100vh;
            background-color: #0f172a;
            color: #e5e7eb;
            padding: 40px 0;
          }

          .page-header {
            text-align: center;
            padding: 40px 20px;
            background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
          }

          .page-header h1 {
            font-size: 2.5rem;
            font-weight: 700;
            margin-bottom: 1rem;
            color: #f1f5f9;
          }

          .page-header p {
            font-size: 1.125rem;
            color: #cbd5e1;
          }

          .content-section {
            padding: 40px 20px;
          }

          .container {
            max-width: 1200px;
            margin: 0 auto;
          }

          .tab-navigation {
            display: flex;
            gap: 1rem;
            margin-bottom: 2rem;
            border-bottom: 1px solid #334155;
          }

          .tab-btn {
            background: transparent;
            color: #cbd5e1;
            border: none;
            padding: 12px 24px;
            cursor: pointer;
            font-size: 1rem;
            font-weight: 500;
            border-bottom: 2px solid transparent;
            transition: all 0.2s;
          }

          .tab-btn:hover {
            color: #f1f5f9;
          }

          .tab-btn.active {
            color: #4ade80;
            border-bottom-color: #4ade80;
          }

          .tab-content {
            margin-top: 2rem;
          }

          .news-section h2,
          .discussions-section h2,
          .tips-section h2 {
            font-size: 1.875rem;
            margin-bottom: 2rem;
            color: #f1f5f9;
          }

          .news-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
            gap: 1.5rem;
          }

          .news-card {
            background-color: #1e293b;
            border-radius: 12px;
            border: 1px solid #334155;
            overflow: hidden;
            transition: all 0.2s;
          }

          .news-card:hover {
            border-color: #4ade80;
            transform: translateY(-2px);
          }

          .news-image {
            height: 200px;
            background: linear-gradient(135deg, #334155 0%, #475569 100%);
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .news-placeholder {
            font-size: 3rem;
          }

          .news-content {
            padding: 1.5rem;
          }

          .news-content h3 {
            font-size: 1.25rem;
            margin-bottom: 0.75rem;
            color: #f1f5f9;
          }

          .news-content p {
            color: #cbd5e1;
            line-height: 1.5;
            margin-bottom: 1rem;
          }

          .news-meta {
            display: flex;
            gap: 1rem;
            font-size: 0.875rem;
            color: #94a3b8;
          }

          .discussions-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
            gap: 1.5rem;
          }

          .discussion-card {
            background-color: #1e293b;
            padding: 1.5rem;
            border-radius: 12px;
            border: 1px solid #334155;
            transition: all 0.2s;
          }

          .discussion-card:hover {
            border-color: #4ade80;
            transform: translateY(-2px);
          }

          .discussion-header {
            display: flex;
            gap: 1rem;
            margin-bottom: 1rem;
          }

          .discussion-avatar {
            width: 40px;
            height: 40px;
            background-color: #334155;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.25rem;
          }

          .discussion-info h3 {
            font-size: 1.125rem;
            margin-bottom: 0.5rem;
            color: #f1f5f9;
          }

          .discussion-info p {
            color: #cbd5e1;
            font-size: 0.875rem;
          }

          .discussion-stats {
            display: flex;
            gap: 1rem;
            font-size: 0.875rem;
            color: #94a3b8;
          }

          .tips-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
            gap: 1.5rem;
          }

          .tip-card {
            background-color: #1e293b;
            padding: 2rem;
            border-radius: 12px;
            border: 1px solid #334155;
            text-align: center;
            transition: all 0.2s;
          }

          .tip-card:hover {
            border-color: #4ade80;
            transform: translateY(-2px);
          }

          .tip-icon {
            font-size: 2.5rem;
            margin-bottom: 1rem;
          }

          .tip-card h3 {
            font-size: 1.25rem;
            margin-bottom: 1rem;
            color: #f1f5f9;
          }

          .tip-card ul {
            list-style: none;
            padding: 0;
            text-align: left;
          }

          .tip-card li {
            color: #cbd5e1;
            margin-bottom: 0.5rem;
            padding-left: 1rem;
            position: relative;
          }

          .tip-card li::before {
            content: "•";
            color: #4ade80;
            position: absolute;
            left: 0;
          }

          @media (max-width: 768px) {
            .page-header h1 {
              font-size: 2rem;
            }

            .news-grid,
            .discussions-grid,
            .tips-grid {
              grid-template-columns: 1fr;
            }

            .discussion-header {
              flex-direction: column;
              text-align: center;
            }
          }
        `}</style>
      </div>
    </AuthGuard>
  );
}

export default DienDan;
